module.exports = __webpack_public_path__ + "img/worm_cylinder_right.prt.f426e15a.jpg";